import React from 'react';
import { Helmet } from 'react-helmet-async';
import AssessmentView from '../../common/assessment/AssessmentView';

function BusinessAssessments() {
    return (
        <>
          <Helmet>
            <title>BVT Business - Assessments</title>
          </Helmet>
          <AssessmentView userType="BUSINESS" />
        </>
      );
}

export default BusinessAssessments; 